import SvgIcon from "./SvgIcon/SvgIcon";

export { default as CarIcon } from "./library/car_icon.svg";
export { default as GreenCircle } from "./library/green_circle.svg";
export { default as MenuIcon } from "./library/menu_icon.svg";
export { default as RedCircle } from "./library/red_circle.svg";

export { default as MailYellow } from "./library/mail-yellow.svg";

export default SvgIcon;
